import React, { useState } from 'react';
import Button from '../../components/common/Button';
import Form from '../../components/OnboardingForm';
import Input from '../../components/common/Input';
import { FlexItem, FlexItemRight } from './styles';
import { Formik } from 'formik';
import * as Yup from 'yup';
import AppModal from 'components/AppModal';
import ConfirmModal from 'pages/Employee/components/ConfirmModal';



const profileSchema = Yup.object().shape({
  current_password: Yup.string()
    .required('Old password is required'),

  new_password: Yup.string()
    .required('Password is required'),

  confirm_password: Yup.string()
    .oneOf([Yup.ref('new_password'), null], 'New password and confirm password must match')
    .required('Confirm password is required'),
});

const PersonalPasswordInfoForm = ({ user, 
  changePasswordDetails,
  isSubmittingChangePassword,
  setshowConfirmPassword,
  showConfirmPassword
 }) => {
  const [passwordValues, setPasswordValues] = useState(null);


 
  const handleSubmit=async (values)=>{
    setshowConfirmPassword(true)
    setPasswordValues(values)
  }

  const handleChangePassword = (values) => {
    changePasswordDetails(passwordValues)

  }


  
  return (
    <>
    <Form title="Password Information">
      <Formik
        enableReinitialize
        initialValues={{
          current_password: '',
          new_password: '',
          confirm_password: ''
        }}
        validationSchema={profileSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          touched,
          handleBlur,
          errors,
          resetForm,
          
        }) => (
          <>
            <FlexItem>
              <Input
                label="Old Password"
                type="password"
                name="current_password"
                placeholder="***********"
                required={false}
                onBlur={handleBlur}
                value={values.current_password}
                onChange={handleChange}
                error={touched.current_password && errors.current_password? errors.current_password:null}
              />
              </FlexItem>

              <FlexItem>
              <Input
                label="New Password"
                type="password"
                name="new_password"
                placeholder="*********"
                required={false}
                onBlur={handleBlur}
                value={values.new_password}
                onChange={handleChange}
                error={touched.new_password && errors.new_password? errors.new_password:null}

              />
            </FlexItem>

            <FlexItem>
              <Input
                label="Confirm Password"
                type="password"
                name="confirm_password"
                placeholder="*********"
                required={false}
                onBlur={handleBlur}
                value={values.confirm_password}
                onChange={handleChange}
                error={touched.confirm_password && errors.confirm_password? errors.confirm_password:null}

              />
            </FlexItem>


            

            <FlexItemRight>
              <Button onClick={handleSubmit} type="button" text="Save Changes" />
            </FlexItemRight>
          </>
        )}
        
      </Formik>
    </Form>

    <AppModal
      show={showConfirmPassword}
      header={false}
      component={
        <ConfirmModal
          actions={
            <div className="delete-content">
              <h6>
                Changing your password will log you out. Do you want to proceed?
              </h6>
            </div>
          }
        />
      }
      previousText="Cancel"
      previous={() => {
        setshowConfirmPassword(false);
      }}
      action={() => handleChangePassword()}
      singleAction={false}
      actionText={isSubmittingChangePassword ? 'Sending...' : 'Continue'}
      // loading={isSubmittingChangePassword} 
      close={() => {
        setshowConfirmPassword(false);
      }}
    />
</>
  );
};

export default PersonalPasswordInfoForm;
